import axios from "axios";

import { domain } from "../config";
import { userStore } from "../store";
import {
  INCREASE_REQUEST,
  DECREASE_REQUEST,
} from "../action/user_action_types";
import moment, { min } from "moment";

export const razorPayKey = process.env.razorpayid;
// export const razorPayKey = "rzp_live_9lcSc6b35o69pB";

export const googleApiKey = process.env.googleApiKey;
// is this correct..??yes
export const setUserData = (data) => {
  localStorage.setItem("userInfo", JSON.stringify(data));
};

export const getUserData = () => {
  const info = localStorage.getItem("userInfo");
  return info ? JSON.parse(info) : null;
};

export const getSalesUserData = () => {
  const info = localStorage.getItem("salesUserInfo");
  return info ? JSON.parse(info) : null;
};

export const setAdminData = (data) => {
  console.log("Admin Info", data);
  localStorage.setItem("adminRole", data.role);
  const info = localStorage.setItem("adminInfo", JSON.stringify(data));
  return info ? JSON.parse(info) : null;
};

export const getAdminData = () => {
  const info = localStorage.getItem("adminInfo");
  return info ? JSON.parse(info) : null;
};

export const setLocalData = (key, data) => {
  const info = localStorage.setItem(key, JSON.stringify(data));
  return info ? JSON.parse(info) : null;
};

export const getLocalData = (key) => {
  const info = localStorage.getItem(key);
  return info ? JSON.parse(info) : null;
};

export const deleteUserData = () => {
  localStorage.clear();
};

export const removeData = (key) => {
  localStorage.removeItem(key);
};

export const axiosInstnace = axios.create({
  baseURL: domain,
});

axiosInstnace.interceptors.request.use(
  (config) => {
    userStore.dispatch({
      type: INCREASE_REQUEST,
    });

    return config;
  },
  (error) => Promise.reject(error)
);

const handleError = () => {
  let url = window.location.href;
  if (url.includes("/admin")) {
    removeData("adminInfo");
    window.location.assign("/admin/login");
  } else if (url.includes("/tp")) {
    removeData("salesUserInfo");
    removeData("userInfo");
    window.location.assign("/tp/login");
  } else {
    removeData("userInfo");
    window.location.assign("/");
  }
};

axiosInstnace.interceptors.response.use(
  (response) => {
    userStore.dispatch({
      type: DECREASE_REQUEST,
    });
    if (response.data.statusCode == 401 && response.data.message) {
      handleError();
    }
    return response;
  },
  (error) => {
    userStore.dispatch({
      type: DECREASE_REQUEST,
    });

    if (error.response.status === 401) {
      handleError();
    }
    if (error.response.status === 400) {
      return Promise.reject(error.response.data.message);
    }
    return Promise.reject(error.response.data.details[0]);
  }
);

export const isAuthenticated = () => !!getUserData();

function idleTimer() {
  let t;
  // window.onload = resetTimer;

  function logout() {
    deleteUserData();
    window.location.href = "/login"; // Adapt to actual logout script
  }

  function resetTimer() {
    clearTimeout(t);
    t = setTimeout(logout, 1800000); // time is in milliseconds (1000 is 1 second)
  }
  window.onmousemove = resetTimer; // catches mouse movements
  window.onmousedown = resetTimer; // catches mouse movements
  window.onclick = resetTimer; // catches mouse clicks
  window.onscroll = resetTimer; // catches scrolling
  window.onkeypress = resetTimer; // catches keyboard actions
}
idleTimer();

export const getDaysForRotationWisePackage = (days) => {
  if (days >= 3 && days < 5) {
    return 5;
  }
  if (days >= 5 && days < 7) {
    return 8;
  } else if (days >= 7 && days < 10) {
    return 10;
  } else if (days >= 10 && days < 15) {
    return 12;
  } else if (days >= 15 && days < 21) {
    return 15;
  } else if (days >= 21 && days < 30) {
    return 18;
  } else if (days === 30) {
    return 20;
  } else {
    return 1;
  }
};

export const getFctForRotationWisePackage = (days) => {
  if (days >= 3 && days < 5) {
    return 5;
  }
  if (days >= 5 && days < 7) {
    return 5;
  } else if (days >= 7 && days < 10) {
    return 7;
  } else if (days >= 10 && days < 15) {
    return 10;
  } else if (days >= 15 && days < 21) {
    return 15;
  } else if (days >= 21 && days < 30) {
    return 21;
  } else if (days === 30) {
    return 30;
  } else {
    return 0;
  }
};

export const getDaysForDaysPackage = (days) => {
  if (days >= 3 && days < 5) {
    return 3;
  }
  if (days >= 5 && days < 7) {
    return 5;
  } else if (days >= 7 && days < 10) {
    return 7;
  } else if (days >= 10 && days < 15) {
    return 10;
  } else if (days >= 15 && days < 21) {
    return 15;
  } else if (days >= 21 && days < 30) {
    return 21;
  } else if (days === 30) {
    days = 30;
    return 30;
  } else {
    return 3;
  }
};
export const checkadminlink = (props, parent, child) => {
  var cl = document.querySelectorAll(".manageSystem-list");
  var parentcl = document.querySelectorAll(".side-menuInner");
  cl[Number(parent)].classList.add("open");
  parentcl[Number(parent)].classList.add("activeDrawer");
  parentcl[Number(parent)].classList.add("active_manager_user");
  cl[Number(parent)].firstElementChild.childNodes[Number(child)].classList.add(
    "activeDrawer"
  );
};

/**
 * generic function to calculate cutoff time for a particular date
 */
export const calculateCutoffTime = (startDate) => {
  let cutoffDate;
  if (
    moment(startDate)
      .subtract(1, "days")
      .get("day") == 0
  ) {
    cutoffDate = 3;
  } else if (
    moment(startDate)
      .subtract(1, "days")
      .get("day") == 6
  ) {
    cutoffDate = 2;
  } else {
    cutoffDate = 1;
  }
  return moment(startDate)
    .subtract(cutoffDate, "days")
    .startOf("d")
    .add(15, "hours");
};

export const getMinimumStartDate = () => {
  let currentTime = moment().hours();
  let day = moment().day();
  let minDay;
  if (currentTime < 15) {
    if (day == 5 || day == 6) {
      minDay = 3;
    } else if (day == 0) {
      minDay = 2;
    } else {
      minDay = 1;
    }
  } else {
    if (day == 5) {
      minDay = 4;
    } else if (day == 6) {
      minDay = 3;
    } else {
      minDay = 2;
    }
  }
  return minDay;
};

export const calculateAmountAndTax = (campaign, includeRefund) => {
  // debugger;
  campaign.actualpackageCost = campaign.amount - campaign.audioCost;
  if(campaign.nonFCTCodeAmount){
    campaign.actualpackageCost = campaign.actualpackageCost - campaign.nonFCTCodeAmount
    campaign.nonFCTCodeAmountTax = Math.round(campaign.nonFCTCodeAmount * 0.18)
    campaign.nonFCTCodeAmountTotal = campaign.nonFCTCodeAmount + campaign.nonFCTCodeAmountTax
  }
  if (campaign.couponPercentage) {
    campaign.couponDiscount = Math.round(
      (campaign.actualpackageCost * campaign.couponPercentage) / 100
    );
    campaign.packageCost = Math.round(
      campaign.actualpackageCost - campaign.couponDiscount
    );
  } else if (campaign.couponDiscount) {
    campaign.packageCost = campaign.actualpackageCost - campaign.couponDiscount;
  } else {
    campaign.packageCost = campaign.actualpackageCost;
  }
  campaign.audioTax = Math.floor(campaign.audioCost * 0.18);
  campaign.audioTotal = campaign.audioCost + campaign.audioTax;
  campaign.packageTax =
    campaign.audioCost == 0
      ? campaign.taxes
      : campaign.taxes - campaign.audioTax;
  if (campaign.couponPercentage || campaign.nonFCTCodeAmount) {
    campaign.packageTax = Math.round(campaign.packageCost * 0.18);
  }
  campaign.packageTotal = campaign.packageCost + campaign.packageTax;
  campaign.totalCost = campaign.packageTotal + campaign.audioTotal + (campaign.nonFCTCodeAmountTotal? campaign.nonFCTCodeAmountTotal: 0) ;
  if (campaign.audioRefundAmount && includeRefund) {
    campaign.totalCost = campaign.totalCost - campaign.audioRefundAmount;
  }
  if (campaign.couponDiscount) {
    // campaign.totalCost = campaign.totalCost - campaign.couponDiscount
  }
  return campaign;
};

export const calculateAudioDuration = (audioDuration) => {
  if (audioDuration <= 10) {
    return 10;
  }
  return audioDuration;
  /* let quotient = Math.floor(audioDuration/5);
  let highestnum = quotient * 5;
  let lowest = highestnum - 2.49, highest = highestnum + 2.50
  return ( audioDuration <= highest && audioDuration >= lowest ) ? highestnum : highestnum + 5*/
};



// WEBPACK FOOTER //
// ./web/util/util.js